'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_config$PrestoConfig(name, address, fetch, login, firebase, turnstile) {
  this.DL = null;
  this.KP = null;
  this.DK = null;
  this.xl = null;
  this.KQ = null;
  this.DM = null;
  this.DL = name;
  this.KP = address;
  this.DK = fetch;
  this.xl = login;
  this.KQ = firebase;
  this.DM = turnstile;
}
export { $c_Lpresto_config$PrestoConfig as $c_Lpresto_config$PrestoConfig };
$p = $c_Lpresto_config$PrestoConfig.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_config$PrestoConfig;
/** @constructor */
function $h_Lpresto_config$PrestoConfig() {
}
export { $h_Lpresto_config$PrestoConfig as $h_Lpresto_config$PrestoConfig };
$h_Lpresto_config$PrestoConfig.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_config$PrestoConfig)) {
    if (((this.DL === x$0.DL) && (this.KP === x$0.KP))) {
      var x = this.DK;
      var x$2 = x$0.DK;
      var $x_2 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.xl;
      var x$4 = x$0.xl;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_BoxesRunTime$().z(this.KQ, x$0.KQ))) {
      var x$5 = this.DM;
      var x$6 = x$0.DM;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 6;
});
$p.s = (function() {
  return "PrestoConfig";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.DL;
      break;
    }
    case 1: {
      return this.KP;
      break;
    }
    case 2: {
      return this.DK;
      break;
    }
    case 3: {
      return this.xl;
      break;
    }
    case 4: {
      return this.KQ;
      break;
    }
    case 5: {
      return this.DM;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_config$PrestoConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j8)));
}
export { $isArrayOf_Lpresto_config$PrestoConfig as $isArrayOf_Lpresto_config$PrestoConfig };
var $d_Lpresto_config$PrestoConfig = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_config$PrestoConfig, "presto.config$PrestoConfig", ({
  j8: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_config$PrestoConfig as $d_Lpresto_config$PrestoConfig };
//# sourceMappingURL=presto.config$-Presto-Config.js.map
